import { Component, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-weekly-usage-limit-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="⚡ High usage alert — student(s) have reached the weekly limit"
      [preambles]="[{
        text: 'The student(s) below have hit 150 minutes of WordFlight this week. '
          + 'Students see the best results when they practice <b>80–120 minutes per week</b> — spaced practice helps learning stick. '
          + 'To protect that, these students have been temporarily paused from WordFlight until Monday.'
      }]"
      [steps]="steps"
      ctaLabel="Open Group Summary report"
      ctaRoute="/reports/system/summary/group"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Usage This Week</th>
          <th class="th">Status</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td"><span class="badge-warn">{{ notification.data.weeklyusage }}</span></td>
            <td class="td"><span class="date-display">Paused until Monday</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true,
})
export class WeeklyUsageLimitNotificationComponent {
  readonly data = input.required<any>();
  readonly steps: NotificationStep[] = [
    {
      title: 'Celebrate their enthusiasm!',
      body: 'This student is clearly motivated — that’s a great thing. Let them know their hard work is noticed and appreciated.',
      variant: 'green',
    },
    {
      title: 'Redirect for the rest of the week',
      body: 'While they’re paused, redirect them to read the WordFlight passages aloud or do another reading activity. They’ll be back in WordFlight on Monday.',
    },
    {
      title: 'Review usage in the Group Summary report',
      body: 'Open the Group Summary and check the <b>Current Week Usage</b> column to see the full picture of where your students are this week.',
    }
  ];
}
